import { Box, Grid, CardMedia, Typography } from "@mui/material";
import {
  Code,
  Commit,
  NavigateNext,
  AccountTreeOutlined,
} from "@mui/icons-material";
import { getLayoutView } from "../../../components/layout/getLayoutView";
import { getLayoutText } from "../../../components/layout/getLayoutText";
const Features = () => {
  return (
    <Box sx={{ p: "6rem 0 5.5rem", backgroundColor: `white` }}>
      <Box data-aos="zoom-in-down" data-aos-offset="300" sx={{ px: `10%` }}>
        {getLayoutView(
          <>
            ENTERS{" "}
            <span style={{ fontFamily: "Lato-Bold" }}> POLYCAIK</span> —
            LET'S GO
          </>,
          [
            getLayoutText(
              <>
                A <span>game development suite</span> that will help you turn
                your ideas into reality
              </>,
              {
                fontSize: "1.25rem",
                fontFamily: "Lato-Regular",
                lineHeight: 2,
                "& span": {
                  fontFamily: "Lato-Bold",
                  color: (theme) => theme.palette.grey[700],
                },
              }
            ),
          ],
          [12],
          {
            p: 0,
            textAlign: `center`,
            backgroundColor: `transparent`,
            "& .MuiTypography-root:not(.MuiTypography-caption)": {
              color: (theme) => theme.palette.grey[700],
            },
          }
        )}
        <Grid
          // data-aos="zoom-in"
          // data-aos-offset="300"
          container
          spacing={5}
          sx={{ mt: 6 }}
        >
          {[
            {
              icon: (p) => <Code {...p} />,
              name: "No Coding Necessary",
              text: "The intuitive interface strips away the coding, so you can focus on what’s important — the building blocks of your game",
            },
            {
              icon: (p) => <AccountTreeOutlined {...p} />,
              name: "Create Organically",
              text: "Our guided workflow breaks down the development process into simplified parts to streamline the creation of your game",
            },
            {
              icon: (p) => <Commit {...p} />,
              name: "Automated Pipeline",
              text: "Configuration and monetization options allow you to deploy your game and generate revenue on the most popular platforms",
            },
          ].map((s, i) => (
            <Grid key={`${s.n}:feature${i}`} item xs={12} sm={6} md={4}>
              {s.icon({ color: "primary", fontSize: "large" })}
              <Typography
                variant="subtitle1"
                textAlign="left"
                sx={{ py: 1, color: (theme) => theme.palette.grey[700] }}
              >
                {s.name}
              </Typography>
              <Typography
                variant="subtitle2"
                textAlign="left"
                sx={{ color: (theme) => theme.palette.grey[700] }}
                fontFamily="Lato-Regular"
                lineHeight={2}
              >
                {s.text}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
      {/* <Grid
        // data-aos="fade-up"
        // data-aos-offset="300"
        container
        sx={{
          pt: 6,
          px: `10%`,
          color: (theme) => theme.palette.grey[600],
        }}
      >
        <Grid
          item
          xs={12}
          lg={7}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: `space-between`,
            "& .wrapper": {
              position: `relative`,
              width: `100%`,
            },
            "& .wrapper::after": {
              position: `absolute`,
              top: 0,
              left: 0,
              width: `100%`,
              height: ` 100%`,
              content: `""`,
              backgroundImage: `linear-gradient(
                0deg,
                white 3%,
                transparent 3%,
                transparent 97%,
                white 97%
              )`,
            },
          }}
        >
          <Box className="wrapper">
            <CardMedia
              component="video"
              image={demo}
              src={demo}
              alt="demo"
              autoPlay
              muted
              loop
            />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ mt: 2 }}>
              APPLY FOR OUR DEVELOPER COHORT
            </Typography>
            <Typography variant="body2" sx={{ mt: 2 }}>
              GET EARLY ACCESS TO THE LATEST FEATURES AND LEARNING MATERIALS TO
              LEVERAGE POLYCAIK IN YOUR WORKFLOWS
            </Typography>
            <Button
              endIcon={<NavigateNext />}
              sx={{
                mt: 4,
                px: 0,
                color: "primary.main",
                backgroundColor: "transparent",
                "&:hover": {
                  color: (theme) => theme.palette.grey[400],
                  backgroundColor: "transparent",
                },
              }}
              href={`/developers`}
            >
              LEARN MORE
            </Button>
          </Box>
        </Grid>
        <Grid item xs={12} lg={5}>
          <Grid
            // data-aos="zoom-in"
            // data-aos-offset="300"
            container
            spacing={5}
            sx={{
              pl: { xs: 0, lg: 8 },
              pt: { xs: 8, lg: 0 },
            }}
          >
            {[
              {
                icon: (p) => <Code {...p} />,
                name: "No Coding Necessary",
                text: "The intuitive interface strips away the coding, so you can focus on what’s important — the building blocks of your game",
              },
              {
                icon: (p) => <AccountTreeOutlined {...p} />,
                name: "Create Organically",
                text: "Our guided workflow breaks down the development process into simplified parts to streamline the creation of your game",
              },
              {
                icon: (p) => <Commit {...p} />,
                name: "Automated Pipeline",
                text: "Configuration and monetization options allow you to deploy your game and generate revenue on the most popular platforms",
              },
            ].map((s, i) => (
              <Grid
                key={`${s.n}:feature${i}`}
                item
                xs={12}
                sm={6}
                md={4}
                lg={12}
              >
                {s.icon({ color: "primary", fontSize: "large" })}
                <Typography
                  variant="subtitle1"
                  textAlign="left"
                  sx={{ py: 1, color: (theme) => theme.palette.grey[700] }}
                >
                  {s.name}
                </Typography>
                <Typography
                  variant="subtitle2"
                  textAlign="left"
                  sx={{ color: (theme) => theme.palette.grey[700] }}
                  fontFamily="Lato-Regular"
                  lineHeight={2}
                >
                  {s.text}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid> */}
    </Box>
  );
};
export default Features;
